import stringifySafe from '../../utils/stringifySafe';

function formatForWrite(id: string, value: unknown) {
  return { id, value: stringifySafe(value) };
}

export default {
  formatForWrite,
};
